import React from "react";
import { motion } from "framer-motion";
import { startCheckout } from "@/lib/checkout";
import { Scale, Shield, Landmark, Building2, Newspaper, FileText, Users, Gavel } from "lucide-react";

const sources = [
  { icon: Scale, name: "Supremo Tribunal Federal", n: "01" },
  { icon: Shield, name: "Polícia Federal", n: "02" },
  { icon: Gavel, name: "Ministério Público", n: "03" },
  { icon: Users, name: "Câmara dos Deputados", n: "04" },
  { icon: Landmark, name: "Senado Federal", n: "05" },
  { icon: FileText, name: "Documentos judiciais", n: "06" },
  { icon: Building2, name: "Documentos públicos", n: "07" },
  { icon: Newspaper, name: "Arquivos jornalísticos", n: "08" },
];

export default function Sources() {
  return (
    <section id="fontes" className="relative bg-[#070707] py-24 md:py-36 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-16 max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Transparência editorial</span>
          </div>
          <h2 className="font-display font-black leading-[0.95] tracking-[-0.02em] text-4xl md:text-6xl text-neutral-50">
            Fontes e <span className="text-red-600 italic">documentos</span>.
          </h2>
          <p className="mt-6 text-neutral-500 text-sm md:text-base max-w-xl leading-relaxed">
            O conteúdo diferencia fatos documentados, acusações, decisões judiciais e interpretações
            políticas. Toda informação apresentada é organizada a partir das categorias abaixo.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {sources.map((s, i) => (
            <motion.div
              key={s.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group relative p-6 border border-white/10 bg-[#0a0a0a] hover:border-red-600/60 transition-colors"
            >
              <div className="flex items-start justify-between mb-6">
                <button
                  type="button"
                  onClick={startCheckout}
                  aria-label={`Comprar ebook — ${s.name}`}
                  className="h-10 w-10 inline-flex items-center justify-center border border-white/10 text-neutral-300 hover:border-red-600 hover:text-red-500 transition-colors"
                >
                  <s.icon className="h-5 w-5" />
                </button>
                <span className="font-mono text-[9px] tracking-[0.3em] text-red-500">
                  {s.n} / 08
                </span>
              </div>
              <div className="font-display text-[17px] text-neutral-50">{s.name}</div>
              <div className="h-[1px] w-6 bg-red-600 mt-4 group-hover:w-full transition-all duration-700" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
